/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 配信目的とテンプレートIDリスト
 * @export
 * @interface PurposeWithTemplateIdList
 */
export interface PurposeWithTemplateIdList {
    /**
     * プレスリリースの目的ID
     * @type {number}
     * @memberof PurposeWithTemplateIdList
     */
    purposeId: number;
    /**
     * 配信目的名
     * @type {string}
     * @memberof PurposeWithTemplateIdList
     */
    purposeName: string;
    /**
     * テンプレートIDリスト
     * @type {Array<number>}
     * @memberof PurposeWithTemplateIdList
     */
    templateIdList: Array<number>;
}

export function PurposeWithTemplateIdListFromJSON(json: any): PurposeWithTemplateIdList {
    return PurposeWithTemplateIdListFromJSONTyped(json, false);
}

export function PurposeWithTemplateIdListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeWithTemplateIdList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purposeId': json['purpose_id'],
        'purposeName': json['purpose_name'],
        'templateIdList': json['template_id_list'],
    };
}

export function PurposeWithTemplateIdListToJSON(value?: PurposeWithTemplateIdList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purpose_id': value.purposeId,
        'purpose_name': value.purposeName,
        'template_id_list': value.templateIdList,
    };
}

